import type { IGridSlice } from './check-slice'
import type { RootState } from '..'

import { createSelector } from 'reselect'

export const getApp = (state: RootState) => state.check

export const selectCheckGrid = createSelector(getApp, (app: IGridSlice) => {
  return app.data
})

export const selectTotal = createSelector(getApp, (app: IGridSlice) => {
  return app.count
})

export const selectStatus = createSelector(getApp, (app: IGridSlice) => {
  return app.isLoadedCheck
})
